/**
 * When any of the values are changed here, do change the jsdoc comments in BaseBox/types/spacingTypes.ts as well
 *
 * {@link ../../components/Box/BaseBox/types/spacingTypes.ts}
 */

export type Spacing = Readonly<{
  /** 0: 0(px/rem/pt) */
  0: 0;
  /** 1: 2(px/rem/pt) */
  1: 2;
  /** 2: 4(px/rem/pt) */
  2: 4;
  /** 3: 8(px/rem/pt) */
  3: 8;
  /** 4: 12(px/rem/pt) */
  4: 12;
  /** 5: 16(px/rem/pt) */
  5: 16;
  /** 6: 20(px/rem/pt) */
  6: 20;
  /** 7: 24(px/rem/pt) */
  7: 24;
  /** 8: 32(px/rem/pt) */
  8: 32;
  /** 9: 40(px/rem/pt) */
  9: 40;
  /** 10: 48(px/rem/pt) */
  10: 48;
  /** 11: 56(px/rem/pt) */
  11: 56;
}>;

export const spacing: Spacing = {
  0: 0,
  1: 2,
  2: 4,
  3: 8,
  4: 12,
  5: 16,
  6: 20,
  7: 24,
  8: 32,
  9: 40,
  10: 48,
  11: 56,
};
